import { useLoadHelpCta } from '../../external-contrib/in-app-help/hooks/useLoadHelpCta';
import GlobalToolbar from '../../components/GlobalToolbar/GlobalToolbar';
import { NavigationComponentsProvider } from '../../components/NavigationComponentsProvider';
import ErrorBoundary from '../../components/ErrorBoundary';
import { jsx as _jsx } from "react/jsx-runtime";
export const HublessNav = () => {
  useLoadHelpCta(true);
  return /*#__PURE__*/_jsx(ErrorBoundary, {
    boundaryName: "Hubless Navigation Root",
    children: /*#__PURE__*/_jsx(NavigationComponentsProvider, {
      children: /*#__PURE__*/_jsx(GlobalToolbar, {})
    })
  });
};